/** 租户详情 /metering/tenant/detail/:id（detail.vue） */
export default {
  tenantDetailPage: {
    btnCopy: '复制',
    totalAssets: '总资产',
    electricAccount: '电费专户',
    waterAccount: '水费专户',
    detailCash: '现金',
    detailDeduction: '抵扣金',
    watermarkNoAccount: '未开户',
    labelPublicArea: '租占面积：',
    labelPostPayComment: '后付费备注：',
    labelElectricAlarm1: '电费预警金额1：',
    labelElectricAlarm2: '电费预警金额2：',
    labelElectricOverdraw: '电费透支金额：',
    labelWaterAlarm1: '水费预警金额1：',
    labelWaterAlarm2: '水费预警金额2：',
    labelWaterOverdraw: '水费透支金额：',
    labelCreateTime: '开户时间：',
    labelPhone: '绑定手机号：',
    labelPhoneN: '绑定手机号{n}：',
    btnCloseAccount: '销户',
    btnRecharge: '充值',
    btnDeduct: '扣款',
    btnEdit: '编辑',
    tabDevice: '设备',
    tabStatistics: '用能报表',
    tabBill: '账单',
    tabTurnover: '资金流水',
    tabRefund: '退款记录',
    tabInvoice: '开票记录',
    invoiceRecords: {
      refresh: '刷新',
      appliedAt: '申请时间',
      subject: '费用类型',
      method: '开票方式',
      title: '发票抬头',
      amount: '开票金额',
      status: '开票状态',
      invoiceNo: '发票号码',
      actions: '操作',
      detail: '详情',
      empty: '暂无开票记录',
      loadFailed: '开票记录加载失败',
      scopeMismatch: '返回的开票记录与当前租户不匹配'
    },
    emptyNotOpen: '暂未开放',
    msgNoViewPerm: '暂无查看权限',
    msgTenantIdEmpty: '租户ID不能为空',
    msgTenantNotFound: '未找到该租户信息',
    msgFetchFail: '获取租户详情失败',
    msgIdEmpty: '租户ID为空',
    msgCopyOk: '复制成功',
    msgCopyFail: '复制失败',
    msgNoClosePerm: '暂无销户权限',
    msgCloseNotSupported: '该租户不支持销户',
    msgNoRechargePerm: '暂无充值权限',
    msgNoDeductPerm: '暂无扣款权限',
    msgNoEditPerm: '暂无编辑权限'
  }
}
